import axios from "axios";

const baseDomain = "";
const version = "1";
const namespace = `wm/v${version}`;
const baseURL = `${baseDomain}/wp-json/${namespace}`;

export default axios.create({
  baseURL,
});
